import { render, staticRenderFns } from "./UpdateCharacter.vue?vue&type=template&id=19a3a6ea"
import script from "./UpdateCharacter.vue?vue&type=script&lang=js"
export * from "./UpdateCharacter.vue?vue&type=script&lang=js"
import style0 from "./UpdateCharacter.vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports